import type { FirebaseOptions } from "firebase/app";

function requiredFirebaseOption(
  value: string | undefined,
  pattern: RegExp,
): string {
  if (typeof value !== "string" || !pattern.test(value)) {
    throw new Error("firebase_configuration_invalid");
  }
  return value;
}

export const CENTRAL_FIREBASE_CONFIG = Object.freeze({
  apiKey: requiredFirebaseOption(
    import.meta.env.VITE_FIREBASE_API_KEY,
    /^AIza[0-9A-Za-z_-]{35}$/,
  ),
  authDomain: requiredFirebaseOption(
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    /^[a-z0-9-]+\.firebaseapp\.com$/,
  ),
  projectId: requiredFirebaseOption(
    import.meta.env.VITE_FIREBASE_PROJECT_ID,
    /^[a-z][a-z0-9-]{4,29}$/,
  ),
  storageBucket: requiredFirebaseOption(
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    /^[a-z0-9-]+\.(?:firebasestorage\.app|appspot\.com)$/,
  ),
  messagingSenderId: requiredFirebaseOption(
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    /^[0-9]{6,32}$/,
  ),
  appId: requiredFirebaseOption(
    import.meta.env.VITE_FIREBASE_APP_ID,
    /^1:[0-9]{6,32}:web:[0-9a-f]{16,64}$/,
  ),
} satisfies FirebaseOptions);
